// SNS処理ヘルパークラス
import { Document } from '@/model/document2/document';
import { Page } from '@/model/document2/page/page';
import { Layer } from "@/model/document2/page/surface/design/layer/layer"
import { Design } from '@/model/document2/page/surface/design/design';
import { DebugHelper } from './debugHelper';
import { ImageHelper } from './imageHelper';
import { TextLayer } from '@/model/document2/page/surface/design/layer/textLayer';
import { RasterImageLayer } from '@/model/document2/page/surface/design/layer/rasterImageLayer';
import { UserAgentHelper } from './userAgentHelper';
import { RequestHelper } from './requestHelper';

import { ReplaceTemplateCommand } from '@/commands/replaceTemplateCommand';
import { Rectangle } from '@/utilityModels/rectangle';
import { Const } from '@/const';
import { putRecentImage } from '@/data/items-recent';
import { Image } from "@/data/image/image"

export class SnsHelper
{
    // コンテンツの適用
    public static applyContents(contents : any, userName : string, userIcon : string, targetDocument : Document, templateDocument : Document, applyInfo : { [key : string] : boolean }, completion : () => void)
    {
        // ユーザーアイコンの画像取得
        this.convertImage(userIcon, userIconImage =>
        {
            var currentDesignPosition = targetDocument.pageList[targetDocument.currentPageIndex].currentDesignPosition;
            this.applyContentsCore(contents, 0, targetDocument.currentPageIndex, currentDesignPosition, userName, userIconImage, targetDocument, templateDocument, applyInfo, () =>
            {
                completion();
            });
        });
    }

    private static applyContentsCore(contents : any, contentIndex : number, pageIndex : number, position : number, userName : string, userIconImage : string, 
        targetDocument : Document, templateDocument : Document, applyInfo : { [key : string] : boolean }, completion : () => void)
    {
        var comp = () =>
        {
            if(contentIndex >= contents.length)
            {
                // 終了
                completion();
                return;
            }

            // デザインを送る
            position++;
            if(position >= targetDocument.pageList[pageIndex].designMaxNumber)
            {
                // ページを送る
                position = 0;
                pageIndex++;
                if(pageIndex >= targetDocument.pageCount)
                {
                    if(targetDocument.pageCount >= Const.MAX_PAGE_NUMBER)
                    {
                        // 最大ページ数だからここで終了
                        completion();
                        return;
                    }
                    // ペー追加
                    var newPage = targetDocument.createNewPage();
                    targetDocument.addPage(newPage);
                }
            }

            // 次の処理へ
            this.applyContentsCore(contents, contentIndex, pageIndex, position, userName, userIconImage, targetDocument, templateDocument, applyInfo, completion);
        };

        var design = targetDocument.pageList[pageIndex].getSurface(targetDocument.isReverseSurface).getDesign(position);
        // カレントか?
        var isCurrentPosition = targetDocument.currentPageIndex == pageIndex && targetDocument.pageList[targetDocument.currentPageIndex].currentDesignPosition == position;
        if(!isCurrentPosition && design != null && design.hasAnyObject(true))
        {
            // カレントでなく、かつすでにオブジェクトが存在する場合はスキップする
            comp();
            return;
        }

        if(design == null)
        {
            // デザインがないので追加
            design = targetDocument.pageList[pageIndex].getSurface(targetDocument.isReverseSurface).createNewDesign(position);
        }

        // テンプレートの差し替え処理
        var command = new ReplaceTemplateCommand(design, templateDocument, true, 0, () => {});
        design.undoRedoManager.do(command);
        design.undoRedoManager.init();

        // 全レイヤー
        var allLayers = design.getAllLayers(false);

        // コンテンツ
        var content = contents[contentIndex++];
        DebugHelper.trace(content);

        // 画像数で分割
        if(applyInfo[Const.SNS_CONTENTS_ACCOUNT_IMAGE] === true){
            var picturesCount = content.pictures.length;
            this.devideImageLayer(allLayers, design, picturesCount);
        }
        else{
            this.deleteLayer(design, allLayers, "画像");
        }
        
        // ユーザー名差し替え
        if(applyInfo[Const.SNS_CONTENTS_ACCOUNT_NAME] === true){
            this.replaceTextLayer(allLayers, "アカウント名", userName);
        }
        else{
            this.deleteLayer(design, allLayers, "アカウント名");
        }
        // 日付差し替え
        if(applyInfo[Const.SNS_CONTENTS_ACCOUNT_DATE_TEXT] === true)
        {
            var dateText = this.formatTimeText(content.created_time);
            this.replaceTextLayer(allLayers, "投稿時間", dateText);
        }
        else{
            this.deleteLayer(design, allLayers, "投稿時間");
        }
        // いいね数差し替え
        if(applyInfo[Const.SNS_CONTENTS_ACCOUNT_FAVORITE_COUNT] === true){
            this.replaceTextLayer(allLayers, "いいね数", "" + content.favorite_count);
        }
        else{
            this.deleteLayer(design, allLayers, "いいね数");
            this.deleteLayer(design, allLayers, "いいねアイコン");
        }
        // メッセージ差し替え
        if(applyInfo[Const.SNS_CONTENTS_ACCOUNT_TEXT] === true){
            this.replaceTextLayer(allLayers, "テキスト", "" + content.message);
        }
        else{
            this.deleteLayer(design, allLayers, "テキスト");
        }

        var finish = () =>
        {
            // 全レイヤーの再取得
            if(design == null)
            {
                comp();
                return;
            }
            allLayers = design.getAllLayers(false);
            // 画像の適用
            this.applyPicture(allLayers, content.pictures, 0, () =>
            {
                // 完了処理
                comp();
            });
        }

        // ユーザー画像差し替え
        if(applyInfo[Const.SNS_CONTENTS_ACCOUNT_ICON] === true)
        {
            this.replaceImageLayer(allLayers, "アイコン", userIconImage, () =>
            {
                DebugHelper.trace("replaceImageLayer is completed");
                finish();
            });
        }
        else
        {
            this.deleteLayer(design, allLayers, "アイコン");

            finish();
        }
    }

    // 画像レイヤーの分割
    private static devideImageLayer(allLayers : Array<Layer>, design : Design, count : number)
    {
        DebugHelper.trace("devideImageLayer")
        DebugHelper.trace("count : " + count);

        if(count == 1) { return; }

        var imageLayer = this.getLayerByName(allLayers, "画像");
        if(imageLayer != null)
        {
            var imageRectangleList : Array<Rectangle> = [];
            if(count == 2)
            {
                // 縦に2分割
                imageRectangleList.push(new Rectangle(imageLayer.x, imageLayer.y, imageLayer.width, imageLayer.height/2));
                imageRectangleList.push(new Rectangle(imageLayer.x, imageLayer.y+imageLayer.height/2, imageLayer.width, imageLayer.height/2));
            }
            else if(count == 3)
            {
                // 十字に3分割
                imageRectangleList.push(new Rectangle(imageLayer.x, imageLayer.y, imageLayer.width/2, imageLayer.height/2));
                imageRectangleList.push(new Rectangle(imageLayer.x, imageLayer.y+imageLayer.height/2, imageLayer.width/2, imageLayer.height/2));
                imageRectangleList.push(new Rectangle(imageLayer.x+imageLayer.width/2, imageLayer.y, imageLayer.width/2, imageLayer.height/2));
            }
            else if(count == 4)
            {
                // 十字に4分割
                imageRectangleList.push(new Rectangle(imageLayer.x, imageLayer.y, imageLayer.width/2, imageLayer.height/2));
                imageRectangleList.push(new Rectangle(imageLayer.x, imageLayer.y+imageLayer.height/2, imageLayer.width/2, imageLayer.height/2));
                imageRectangleList.push(new Rectangle(imageLayer.x+imageLayer.width/2, imageLayer.y, imageLayer.width/2, imageLayer.height/2));
                imageRectangleList.push(new Rectangle(imageLayer.x+imageLayer.width/2, imageLayer.y+imageLayer.height/2, imageLayer.width/2, imageLayer.height/2));
            }

            for(var i = 0; i < imageRectangleList.length; ++i)
            {
                var rect = imageRectangleList[i];
                var layer = imageLayer;
                if(i > 0)
                {
                    // クローンをとる
                    layer = imageLayer.clone();
                    // レイヤーを挿入する
                    design.layer.insertLayer(design.layer.getLayerIndex(imageLayer), layer);
                }
                // レイヤーのリネーム
                layer.name = "画像" + (i + 1);
                // レイヤーのリサイズ
                layer.x = rect.x;
                layer.y = rect.y;
                layer.width = rect.width;
                layer.height = rect.height;
            }
        }
    }

    private static applyPicture(allLayers : Array<Layer>, pictures : Array<string>, pictureIndex : number, completion : () => void)
    {
        DebugHelper.trace("picture : " + pictureIndex + " / " + pictures.length);
        if(pictureIndex == 0 && pictures.length == 0)
        {
            completion();
            return;
        }

        var picture = pictures[pictureIndex];
        // 画像取得
        this.convertImage(picture, pictureImage =>
        {
            // 画像差し替え
            var imageLayerName = pictures.length > 1 ? "画像" + (pictureIndex + 1) : "画像";
            this.replaceImageLayer(allLayers, imageLayerName, pictureImage, () =>
            {
                pictureIndex++;
                if(pictureIndex >= pictures.length)
                {
                    // 次の画像がなければ完了
                    completion();
                }
                else
                {
                    // 次の画像を処理する
                    this.applyPicture(allLayers, pictures, pictureIndex, completion);
                }
            });
        });
    }

    // テキストレイヤー差し替え
    private static replaceTextLayer(allLayers : Array<Layer>, name : string, text : string)
    {
        var layer = this.getLayerByName(allLayers, name);
        if(layer != null && layer instanceof TextLayer)
        {
            // テキスト書き換え
            layer.changeText(text);
        }
    }

    // 画像レイヤー差し替え
    private static replaceImageLayer(allLayers : Array<Layer>, name : string, image : string, completion : () => void)
    {
        ImageHelper.getImageSize(image, size => 
        {
            var layer = this.getLayerByName(allLayers, name);

            if(layer == null || !(layer instanceof RasterImageLayer))
            {
                completion();
                return;
            }
            var layerRatio = layer.width / layer.height;
            var imageRatio = size.width / size.height;
            var newWidth = 100;
            var newHeight = 100;
            if(imageRatio < layerRatio)
            {
                // レイヤーが横長
                newHeight = (size.width / layerRatio) / size.height * 100;
            }
            else
            {
                // レイヤーが縦長
                newWidth = (size.height * layerRatio) / size.width * 100;
            }
            // 画像をクロップ
            ImageHelper.cropImageNormalized(image, (100 - newWidth) / 2, (100 - newHeight) / 2, newWidth, newHeight, croppedImage => 
            {
                ImageHelper.getImageSize(croppedImage, croppedSize =>
                {
                    // 白色透明化
                    ImageHelper.createWhiteTransparentImage(croppedImage, whiteTransparentImage => {
                        if(layer == null || !(layer instanceof RasterImageLayer))
                        {
                            completion();
                            return;
                        }
                        // 画像の差し替え
                        layer.imageBase64 = croppedImage;
                        layer.imageBase64Origin = croppedImage;
                        layer.imageBase64WhiteTransparent = whiteTransparentImage;
                        layer.imageBase64WhiteTransparentOrigin = whiteTransparentImage;
                        layer.imageWidth = croppedSize.width;
                        layer.imageHeight = croppedSize.height;

                        // 完了
                        completion();
                    });
                });
            });
        });
    }

    // レイヤー消去
    private static deleteLayer(design : Design, allLayers : Array<Layer>, name : string)
    {
        var layer = this.getLayerByName(allLayers, name);
        if(layer != null)
        {
            var parent = design.getParentLayer(layer);

            if(parent != null)
            {
                parent.removeLayer(layer);
                DebugHelper.trace("removeDone");
            }
        }
    }

    // 時間テキストをフォーマットする
    private static formatTimeText(text : string)
    {
        var result = "";
        try
        {
            var year = parseInt(text.substr(0, 4));
            var month = parseInt(text.substr(5, 2));
            var day = parseInt(text.substr(8, 2));
            var hour = parseInt(text.substr(11, 2));
            var minite = parseInt(text.substr(14, 2));

            result = year + "年" + month + "月" + day + "日" + "　" + hour + ":" + minite;
        }
        catch(e)
        {
            DebugHelper.trace(e);
        }

        return result;
    }

    // 画像のbase64を得て、完了処理で返す
    private static convertImage(url : string, completion : (image : string) => void)
    {
        if(UserAgentHelper.getBrowser() == "edge"){
            const params = { path : url };

            RequestHelper.post("png_base64_encode", params, (response) => {
                try {
                    var responseData = JSON.parse(response);
                    var data = responseData.data.base64Image;
                    
                    completion(data);

                    // this.addImageLayer(url, data);
                } catch(e) {
                    DebugHelper.trace(e);
                    completion("");
                }
            }, () => {
                DebugHelper.trace("error");
                completion("");
            });
        }
        else{
            ImageHelper.getImageFromUrl(url, image => 
            {
                completion(image);
            });
        }
    }

    private static getLayerByName(allLayers : Array<Layer>, name : string) : Layer | null
    {
        for(var i = 0; i < allLayers.length; ++i)
        {
            var layer = allLayers[i];
            if(layer.name == name)
            {
                return layer;
            }
        }
        return null;
    }
}